import React from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { Layout } from 'fronton-react';

type SecondarySectionProps = {
  children: React.ReactNode;
  className?: string;
};

export const secondarySectionLayout = css`
  @media (--only-largeDesktop) {
    margin-bottom: 80px;
  }

  @media (--only-desktop) {
    margin-bottom: 64px;
  }

  @media (--only-tablet) {
    margin-bottom: 64px;
  }

  @media (--to-desktop) {
    width: 100%;
    padding: 0;
    margin-right: 0;
    margin-left: 0;
    background-color: var(--background-secondary);
  }

  @media (--only-mobile) {
    margin-bottom: 40px;
  }
`;

export const secondarySection = css`
  @media (--from-desktop) {
    width: 100%;
    padding: 40px;
    margin: 0;
    background-color: var(--background-secondary);
    border-radius: var(--rounding-l);
  }

  @media (--only-tablet) {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  @media (--only-mobile) {
    padding-top: 32px;
    padding-bottom: 32px;
  }
`;

export const SecondarySection: React.FC<SecondarySectionProps> = ({ children, className }) => (
  <Layout as="section" className={cn(className, secondarySectionLayout)}>
    <Layout className={secondarySection}>{children}</Layout>
  </Layout>
);
